import control from './controls/control';
import constants from './constants';

const getExtension = () => ({
  slug: constants.common.slug,
  title: 'Online Store Extension',
  description: 'Extension to work with Online Store',
  settings: {
    querySelector: 'ws-online-store',
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
